import useConfig from 'modules/config/state/use-config'
import useOrder from 'modules/order/state/order/use-order'
import { usePrefetchPaypalToken } from 'redux/services/paypal'
import { usePrefetchPaymentMethods } from 'redux/services/paymentMethods'
import useStripePaymentRequest from 'utils/functions/useStripePaymentRequest'
import { useMemo } from 'react'
import { usePrefetchPlaidToken } from 'redux/services/plaid'

/**
 * Prefetch & preload Stripe, Digital Wallets, Paypal token
 */
const useInitializePaymentMethods = () => {
  const order = useOrder()
  const config = useConfig()

  const campaignId = useMemo(() => config.campaignId, [config.campaignId])
  const currency = useMemo(() => order.currency.value, [order.currency.value])

  // Directly call the hooks here
  usePrefetchPaymentMethods(campaignId, currency)
  usePrefetchPaypalToken(campaignId, currency)
  usePrefetchPlaidToken(campaignId, currency)

  // Initialize digital wallets
  useStripePaymentRequest()
}

export default useInitializePaymentMethods
